import { useEffect } from 'react';
import { getSessionBrand, useSession } from '../../../../infra/session';
import { getHex, isHexColor, rgbToHex } from '../../components/color-picker-button/utils';
import { useEditableField } from './use-editable-field';
export var getDefaultCtaColor = function () {
    var rootElement = document.documentElement;
    var defaultBackgroundColor = getComputedStyle(rootElement).getPropertyValue('--Background-Primary-Inverse');
    if (isHexColor(defaultBackgroundColor))
        return defaultBackgroundColor;
    if (defaultBackgroundColor.startsWith('rgb'))
        return rgbToHex(defaultBackgroundColor);
    return '#FFFFFF';
};
export var useSetupDefaultCtaColor = function () {
    var session = useSession().data;
    var setCtaColor = useEditableField('ctaColor').setValue;
    useEffect(function () {
        var extension = getSessionBrand(session).extension;
        if (extension === null || extension === void 0 ? void 0 : extension.primaryColor) {
            var initialColorBrand = getHex(extension === null || extension === void 0 ? void 0 : extension.primaryColor);
            setCtaColor(initialColorBrand);
        }
    }, [session, setCtaColor]);
};
